import { useSetAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { chatFeedWriteAtom } from '../atoms';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { allDimensionsListSelector } from '@store/common/dimensionList/selectors';

function useHandleUserMessage({ getStream }) {
  const updateLastChatBlock = useSetAtom(chatFeedWriteAtom);
  const allDimensions = useSelector(allDimensionsListSelector);

  const submitQuestion = (userMsg) => {
    const curCanceler = new AbortController();
    // new chat
    updateLastChatBlock(
      {
        userMsg,
        canceler: curCanceler,
      },
      true,
    );

    getStream(
      {
        query: userMsg,
        product: CURRENT_PRODUCT_MODE,
        dimensions: allDimensions,
        parameters: [
          {
            key: 'session.spi_mobile_app_startup_time_threshold',
            val: 1,
          },
          {
            key: 'session.spi_app_crash_threshold',
            val: 1,
          },
          {
            key: 'session.spi_screen_load_threshold',
            val: 1,
          },
          {
            key: 'session.spi_page_load_threshold',
            val: 5,
          },
        ],
      },
      curCanceler,
    );
  };

  return { submitQuestion };
}

export default useHandleUserMessage;
